import { useCallback } from 'react'
import { useAppDispatch } from '@/app/hooks'
import apiClient, { setAuthToken } from '@/lib/api/apiClient'
import { API_ENDPOINTS } from '@/lib/api/config'
import { parseVerifyUserResponse } from '@/lib/api/userService'
import { STORAGE_KEYS } from '@/constants/storageKeys'
import { clearImpersonationSessionFilters } from '@/lib/auth/impersonationSessionFilters'
import { getCurrentPathForImpersonateReturn } from '@/lib/utils/impersonateReturnPath'
import { setAuthFromToken } from '@/features/auth/authSlice'
import { showValidationMessage, formatApiError } from '@/lib/utils/notifications'

export function useUserManagementEditImpersonate() {
  const dispatch = useAppDispatch()

  const handleImpersonate = useCallback(
    async (roleId: number, roleName: string) => {
      try {
        const currentToken = localStorage.getItem(STORAGE_KEYS.authToken)
        if (currentToken) localStorage.setItem('admin_token', currentToken)
        const returnPath = getCurrentPathForImpersonateReturn()
        localStorage.setItem('impersonate_path', returnPath)
        localStorage.setItem('impersonatepath', returnPath)
        sessionStorage.setItem('impersonate_process', '1')

        const res = await apiClient.post(API_ENDPOINTS.IMPERSONATE, { role_id: roleId })
        const data = res.data as { token?: string; ott?: string } | string
        const token = typeof data === 'string' ? data : data?.token
        if (!token) {
          showValidationMessage('Impersonate response missing token.', 'Impersonate Error')
          return
        }

        localStorage.setItem('old_token', currentToken || '')
        setAuthToken(token)

        const verifyRes = await apiClient.get('/api/verify?force')
        const userData = parseVerifyUserResponse(verifyRes.data)
        dispatch(setAuthFromToken({ token, user: userData }))
        try {
          localStorage.setItem('user', JSON.stringify(userData))
        } catch {
          /* ignore */
        }
        localStorage.setItem('impersonate', 'true')
        clearImpersonationSessionFilters()

        window.location.href =
          roleName === 'ROLE_RENTER' ? '/resident-application/active' : '/dashboard'
      } catch (err) {
        if (localStorage.getItem('impersonate') !== 'true') {
          localStorage.removeItem('admin_token')
          sessionStorage.removeItem('impersonate_process')
        }
        showValidationMessage(formatApiError(err), 'Impersonate Error')
      }
    },
    [dispatch],
  )

  return { handleImpersonate }
}
